// extracted by mini-css-extract-plugin
export default {"wrapper":"yMDuJI4_","right":"xmqSWFDl","title":"fgPY_kI_","discussionLink":"Yw1DDH62","discussionTitle":"YRhFkWt0"};